import React, { useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, Typography, Box, CircularProgress, Alert, IconButton
} from '@mui/material';
import { userService } from '../../services/api';
import { groupService } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { Close as CloseIcon } from '@mui/icons-material';

            
const BulkDeleteModal = ({ open, onClose, ids=[], onSuccess ,deleteFunction,itemName='item',title= 'Delete Items' }) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            // You'll need to create this API endpoint
            // const response = await userService.bulkDeleteUsers(userIds);
            const response = await deleteFunction(ids); 
            if (response.data.success) {
                onSuccess();
            } else {
                 showToast(response.data.message || `Failed to delete ${itemName}s`, 'error');
            }
        } catch (error) {
            // console.error('Error deleting users:', error);
            // showToast('Error deleting users', 'error');
            console.error(`Error deleting ${itemName}s:`, error);
            showToast(`Error deleting ${itemName}s`, 'error');
        } finally {
            setLoading(false);
        }
    };

return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">{title}</Typography>
                    <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                {/* <Alert severity="warning" sx={{ mb: 2 }}>
                    This action cannot be undone.
                </Alert> */}
                <Alert severity="warning" sx={{ mb: 2 }}>
                {itemName === 'user' ? (
                        <>
                            The user will not be permanently deleted. Instead, they will be moved to the <strong>purge list</strong>.
                        </>
                    ) : (
                        "This action cannot be undone."
                    )}
                </Alert>

                <Box sx={{ mb: 2 }}>
                    <Typography variant="body1" fontWeight="bold">
                        Are you sure you want to delete {ids.length} {itemName}{ids.length > 1 ? 's' : ''}?
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button 
                    onClick={handleSubmit} 
                    variant="contained" 
                    color="primary"
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );

};

export default BulkDeleteModal;
